export default {
  strict: true,
  namespaced: true,
  state: {
    list: [],
    loading: false,
    showBrandForm: false,
    order: 'name',
    orderAsc: 1,
    editBrands: {},
    webform: {
      list: [],
      loading: true,
      show: false,
      edit: {},
      rerender: 0,
      order: 'name',
      orderAsc: 1
    },
    serviceArea: {
      list: [],
      loading: false
    },
    charterEnabled: []
  },
  mutations: {
    setList (state, value) { state.list = value },
    setLoading (state, value) { state.loading = value },
    setShowBrandForm (state, value) { state.showBrandForm = value },
    setBrandOrder (state, value) { state.order = value },
    setBrandOrderAsc (state, value) { state.orderAsc = value },
    setEditBrands (state, value) { state.editBrands = value },
    setWebformList (state, value) { state.webform.list = value },
    updatedWebform (state, data) {
      let index = state.webform.list.findIndex(x => x.id === data.id)
      state.webform.list[index].geofencesIDs = data.geofencesIDs
    },
    setWebformLoading (state, value) { state.webform.loading = value },
    setWebformShow (state, value) { state.webform.show = value },
    setWebformEdit (state, value) { state.webform.edit = value },
    setWebformRerender (state, value) { state.webform.rerender = value },
    setServiceAreaList (state, value) { state.serviceArea.list = value },
    seterviceAreaLoading (state, value) { state.serviceArea.loading = value },
    setBrandData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/brands.js